// pages/Blog.jsx (Original layout structure preserved)
import React, { useState, useEffect } from "react";
import BlogList from '../components/BlogList.jsx';
import CategoryButtons from "./components/CategoryButtons.jsx";
import styles from "../style.js";
import Footer from "../components/Footer.jsx";
import blogService from '../services/blogServices.js';
import { Reveal } from "../components/reveal.jsx";
import { Link, useNavigate } from 'react-router-dom';
import { img2 } from "../assets/index.js";

const Publication = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [blogs, setBlogs] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
const navigate = useNavigate();

  const categories = [
    'Newsroom', 'Stories', 'Events', 
    'Companies', 'Business'
  ];

  useEffect(() => {
  // Check authentication status
  const authStatus = localStorage.getItem('isAuthenticated') === 'true';
    setIsAuthenticated(authStatus);
  }, []);

  const handleAddBlog = () => {
    navigate('/BlogWrite');
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Load blogs
    loadBlogs();
    
    // Subscribe to blog updates
    const unsubscribe = blogService.addListener(() => {
      loadBlogs();
    });
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      unsubscribe();
    };
  }, []);

  const loadBlogs = () => {
    setLoading(true);
    const publishedBlogs = blogService.getPublishedBlogs();
    setBlogs(publishedBlogs);
    setLoading(false);
  };

  // Filter blogs by selected category (similar to your pattern)
  const filteredBlogs = !selectedCategory 
    ? blogs 
    : blogs.filter(blog => blog.category === selectedCategory);
    
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          <p className="mt-4 text-gray-600">Loading blogs...</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`bg-primary flex flex-col`}
      style={{ 
          backgroundImage: `url(${img2})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        }}
      >
      <div className="pt-80 pb-16 flex flex-col gap-10 items-center w-full">
        <Reveal>
          <h1 className="pb-6 text-white text-center font-semibold text-md leading-[30px] xs:leading-[50px] xs:max-w-[640px] max-w-[400px]">
            Publications
          </h1>
        </Reveal>
        <Reveal>
          <p className={`kerning-normal xs:text-sm text-ss xs:max-w-[470px] max-w-[360px] mt-5 text-tertiary text-center`}>
            At AfriNext, we are passionate about empowering tomorrow's game changers and industry disruptors. This is where entrepreneurial dreams meet strategic investment, and where groundbreaking ideas are nurtured into reality.
          </p>
        </Reveal>
        {isAuthenticated && (
          <button
            type="button"
            onClick={handleAddBlog}
            className="text-red-500 hover:text-red-700 py-10"
          >
            Add publication
          </button>
        )}
      </div>  
      <div className={`sticky top-24 z-10 !important ${styles.flexCenter} flex-col gap-5`}>
        <div className="w-full overflow-x-auto overflow-y-hidden" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch'}}>
          <div className="flex flex-nowrap gap-2 px-4 py-2 h-[40px] items-center justify-center" style={{ minWidth: 'max-content' }}>
            <CategoryButtons
              categories={categories} 
              selectedCategory={selectedCategory}
              onSelectCategory={setSelectedCategory}
            />
          </div>
        </div>
        {window.innerWidth < 768 && (
          <p className={`text-ss text-secondary text-center animate-pulse`}>
            -+-- scroll categories sideways --+-
          </p>
        )}
      </div>
      <BlogList products={filteredBlogs}/>         
      <Footer />
    </div>
  );
};

export default Publication;